import { render, staticRenderFns } from "./OrdersReportFiltersModal.vue?vue&type=template&id=2672b854&scoped=true"
import script from "./OrdersReportFiltersModal.vue?vue&type=script&lang=ts"
export * from "./OrdersReportFiltersModal.vue?vue&type=script&lang=ts"
import style0 from "./OrdersReportFiltersModal.vue?vue&type=style&index=0&id=2672b854&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2672b854",
  null
  
)

export default component.exports